import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  GridContainer,
  GridItem,
  DataCard,
  DataCardHeader,
  DataCardTitle,
  SummaryGrid,
  SummaryItem,
  SummaryLabel,
  SummaryValue,
} from "./MonthlyReport.styles";
import { Business, Receipt } from "@mui/icons-material";
import { formatNumber, isPositiveAmount } from "./MonthlyReport.utils";
import MonthlyReportMerchantsTable from "./MonthlyReport.merchantsTable";

const MonthlyReportISOAccordion = ({ isos }) => {
  if (!isos || isos.length === 0) return null;

  return (
    <GridItem xs={12} padding="0 0 15px 0">
      <DataCard>
        <DataCardHeader>
          <Business color="primary" />
          <DataCardTitle>ISOs</DataCardTitle>
        </DataCardHeader>
        {isos.map((iso, isoIndex) => (
          <Accordion key={isoIndex}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <GridContainer spacing={0} alignItems="center">
                <GridItem xs={12} sm={6}>
                  <Typography variant="h6">{iso.isoName || iso.isoID}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    ISO ID: {iso.isoID}
                  </Typography>
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">
                    Net Residual
                  </Typography>
                  <SummaryValue positive={isPositiveAmount(iso.summary?.total_fees)}>
                    ${formatNumber(iso.summary?.total_fees)}
                  </SummaryValue>
                </GridItem>
              </GridContainer>
            </AccordionSummary>
            <AccordionDetails>
              <GridContainer>
                {/* ISO Summary */}
                <GridItem xs={12} padding="0 0 15px 0">
                  <DataCard>
                    <DataCardHeader>
                      <Receipt color="primary" />
                      <DataCardTitle>ISO Summary</DataCardTitle>
                    </DataCardHeader>
                    <SummaryGrid spacing={0} style={{ marginTop: "16px" }}>
                      <GridItem xs={12} sm={6}>
                        <SummaryItem>
                          <SummaryLabel>Amount</SummaryLabel>
                          <SummaryValue>${formatNumber(iso.summary?.total_transaction_amount)}</SummaryValue>
                        </SummaryItem>
                      </GridItem>
                      <GridItem xs={12} sm={6}>
                        <SummaryItem>
                          <SummaryLabel>Transactions</SummaryLabel>
                          <SummaryValue>{iso.summary?.total_transaction_count || 0}</SummaryValue>
                        </SummaryItem>
                      </GridItem>
                    </SummaryGrid>
                  </DataCard>
                </GridItem>

                {/* ISO Merchants */}
                <MonthlyReportMerchantsTable merchants={iso.merchants} />
              </GridContainer>
            </AccordionDetails>
          </Accordion>
        ))}
      </DataCard>
    </GridItem>
  );
};

export default MonthlyReportISOAccordion;

